import clsx from 'clsx'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

function Breadcrumbs({ crumbs, className }: BreadcrumbsProps) {
  const { t } = useTranslation('global')

  return (
    <div className={clsx('flex items-center box', className)}>
      <Link href="/">
        <p className="text-sm font-medium flex items-center text-sbtgray-350 cursor-pointer after:inline-block after:mx-2 after:text-2xl after:font-medium after:text-sbtgray-200 after:content-['/'] last:text-[#1EBFB4] last:after:content-[''] last:cursor-default last:font-semibold last:pointer-events-none">
          {t('main_page')}
        </p>
      </Link>
      {crumbs.map((crumb: Crumb) => (
        <Link key={crumb.label} href={crumb.url ?? '#'}>
          <p className="text-sm font-medium flex items-center text-sbtgray-350 cursor-pointer after:inline-block after:mx-2 after:text-2xl after:font-medium after:text-sbtgray-200 after:content-['/'] last:text-[#1EBFB4] last:after:content-[''] last:cursor-default last:font-semibold last:pointer-events-none">
            {crumb.label}
          </p>
        </Link>
      ))}
    </div>
  )
}

interface BreadcrumbsProps {
  crumbs: Crumb[]
  className?: string
}

type Crumb = {
  url?: string
  label: string
}

export default Breadcrumbs
